// extracted by mini-css-extract-plugin
export default {"pageTitle":"staff_pageTitle__8j6gX","staffMember":"staff_staffMember__u8kkc"};